<template lang="html">
  <b-row>
    <b-col>
      <b-alert show variant="info" dismissible>
        <h5>
          Baritone tuning 👀
        </h5>
        <p>
          You're viewing videos specifially created for
          <strong>G (baritone ukulele)</strong> tuning. There aren't many of
          these videos online, but we're hoping to see more in the future. If
          you find any Baritone specific play-alongs or tutorials online, please
          <b-link :to="{ name: 'public-submit' }">let us know</b-link>.
        </p>
        <!--
        <p>
          You're viewing chord shapes for
          <strong>G (baritone ukulele)</strong> tuning. The chord
          <strong>names</strong> will be correct in the videos, but the chord
          <strong>shapes</strong> will not. To play along to the videos in G
          tuning, you'll need to use the chord shapes displayed below.
        </p>
      -->
        <p class="mb-0">
          <b-btn size="sm" variant="info" @click="gotoStandardChords">
            Take me back to C tuning
          </b-btn>
        </p>
      </b-alert>
    </b-col>
  </b-row>
</template>

<script>
export default {
  name: "NonStandardTuningWarning",
  methods: {
    gotoStandardChords() {
      var route = this.$route;
      var _v = this;
      this.$store.dispatch("setTuning", "C").then(function() {
        _v.$router.push({ name: route.name, params: { tuning: "C" } });
      });
    }
  }
};
</script>

<style lang="css" scoped></style>
